import { render } from "./productSvg.vue?vue&type=template&id=2d45e6d4"
import script from "./productSvg.vue?vue&type=script&lang=js"
export * from "./productSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__